// extracted by mini-css-extract-plugin
export var list = "newsList-module--list--3l8V6";
export var listwrap = "newsList-module--listwrap--3yA25";
export var jsAnimInit = "newsList-module--jsAnimInit--3nDWi";